import { z } from 'zod';

/**
 * Schema for index page settings form validation
 */
export const indexPageSettingsSchema = z.object({
  reviewsWidgetCode: z.string().nullable().optional()
});

/**
 * Form data type for index page settings
 */
export type IndexPageSettingsFormData = z.infer<typeof indexPageSettingsSchema>;
